import { render, staticRenderFns } from "./TedsLauncherMain.vue?vue&type=template&id=39950151&"
import script from "./TedsLauncherMain.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherMain.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports